import React, { useMemo } from 'react'
import { Text, TooltipText, useTooltip } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'

const EarlyUnlockFee: React.FC<{
  lockAt: number;
  duration: number;
  epochTime: number;
}> = ({ lockAt, duration, epochTime }) => {
  const { t } = useTranslation()

  const unlockPenaltyFee = useMemo(() => {
    return Math.max(
      0,
      Math.floor((duration - epochTime + lockAt) * 10000 / duration) / 100)
  }, [lockAt, duration, epochTime])

  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    <>
      <Text>
        {t('Locked since %lockAt%', { lockAt: new Date(lockAt * 1000).toLocaleString() })}
      </Text>
      <Text>
        {t('Locked for %duration% days', { duration: Math.floor(duration / 3600 / 24) })}
      </Text>
      {
        unlockPenaltyFee > 0 && (
          <Text>
            {t('If you unlock now, %unlockPenaltyFee%% early unlock penalty fee will be applied', {
              unlockPenaltyFee
            })}
          </Text>
        )
      }
    </>,
    { placement: 'bottom-start' },
  )

  return (
    <>
      {tooltipVisible && tooltip}
      <TooltipText ref={targetRef} small textTransform="lowercase">
        {unlockPenaltyFee}% early unlock penalty fee
      </TooltipText>
    </>
  )
}

export default EarlyUnlockFee
